import { render, staticRenderFns } from "./FutureCard.vue?vue&type=template&id=6f37584b&scoped=true&"
import script from "./FutureCard.vue?vue&type=script&lang=js&"
export * from "./FutureCard.vue?vue&type=script&lang=js&"
import style0 from "./FutureCard.vue?vue&type=style&index=0&id=6f37584b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f37584b",
  null
  
)

export default component.exports